import { apiSend } from "./http";

/**
 * POST /api/payments/pay — create a payment.
 * `user_id`/`phone` come from getDecoderOwner() for the decoder-id payment flow
 * and are optional: undefined values are dropped from the body by JSON.stringify,
 * so the authenticated (provider + amount only) flow keeps working unchanged.
 * Returns the raw Response so the caller can read body + status.
 */
export async function createPayment({ user_id, phone, provider, amount }) {
  return apiSend("/payments/pay", "POST", { user_id, phone, provider, amount });
}

// POST /api/user/invoice — create an invoice, returns { invoice_id, ... }.
export async function createInvoice({ amount, currency }) {
  const response = await apiSend("/api/user/invoice", "POST", {
    amount,
    currency,
  });
  if (!response.ok) throw new Error("Network response was not ok");
  return response.json();
}
